import { fromZonedTime } from 'date-fns-tz/fromZonedTime';

import { ZonedDate } from '@eika-infrastruktur/date';

const nullableZoneddateToUtc = (date?: ZonedDate) => {
    if (!date) return undefined;
    return fromZonedTime(date, date.timeZone).toISOString();
};

export default nullableZoneddateToUtc;
